import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "flex justify-between items-center py-10" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Switcher, {
            modelValue: _ctx.tab_show,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab_show) = $event)),
            options: ['Ordini di acquisto', 'Ordini di vendita']
          }, null, 8, ["modelValue"]),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible=true)),
            class: "ml-3 py-2 px-4 m-0 hidden sm:flex items-center"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" + Aggiungi ")
            ])),
            _: 1
          })
        ]),
        (!_ctx.tab_show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5",
                  cols: _ctx.cols,
                  "onUpdate:cols": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cols) = $event)),
                  rows: _ctx.rowsAcquisto,
                  onOrderUpdate: ($event: any) => (void(0))
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.rowsAcquisto, (c, j) => {
                    return {
                      name: `td_${j}_1`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.progetto.azienda.denominazione), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsAcquisto, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.budget_consuntivo), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsAcquisto, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.totale_costi), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsAcquisto, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.totale_ricavi), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsAcquisto, (c, j) => {
                    return {
                      name: `td_${j}_7`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioSottoProgetto', params:{id:context.context.row.id}},
                          class: "block text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.fetchNextAcquisto,
                identifier: _ctx.infiniteIdentifierAcquisto,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4 pl-5",
                  cols: _ctx.cols,
                  "onUpdate:cols": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cols) = $event)),
                  rows: _ctx.rowsVendita,
                  onOrderUpdate: ($event: any) => (void(0))
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.rowsVendita, (c, j) => {
                    return {
                      name: `td_${j}_1`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.progetto.azienda.denominazione), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsVendita, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.budget_consuntivo), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsVendita, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.totale_costi), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsVendita, (c, j) => {
                    return {
                      name: `td_${j}_6`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(context.context.row.dati.totale_ricavi), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.rowsVendita, (c, j) => {
                    return {
                      name: `td_${j}_7`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioSottoProgetto', params:{id:context.context.row.id}},
                          class: "block text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.fetchNextVendita,
                identifier: _ctx.infiniteIdentifierVendita,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}